import { byAttrVal, createCustomElement, DOMModel } from '@adobe/react-webcomponent'
import React, { ReactElement } from 'react'

import { OverdueInvoiceLockedAccountView } from '@views/overdueInvoiceLockedAccountView'

import { ThemeProvider } from '../../contexts/themeProvider'

const MODULE_NAME = 'organization-not-owner-and-overdue-invoice-locked-box'

class OverdueInvoiceLockedAccountViewWebComponent extends DOMModel {
  @byAttrVal error: string
}

const OverdueInvoiceLockedAccountViewModule = (): ReactElement => (
  <ThemeProvider>
    <OverdueInvoiceLockedAccountView />
  </ThemeProvider>
)

const OverdueInvoiceLockedAccountViewElement = createCustomElement(
  OverdueInvoiceLockedAccountViewModule,
  OverdueInvoiceLockedAccountViewWebComponent,
  'element',
)

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, OverdueInvoiceLockedAccountViewElement)

export default OverdueInvoiceLockedAccountViewElement
